import script from "./UPhoneNumber.vue?vue&type=script&setup=true&lang=ts"
export * from "./UPhoneNumber.vue?vue&type=script&setup=true&lang=ts"

import "./UPhoneNumber.vue?vue&type=style&index=0&id=5746bd9d&lang=css"

const __exports__ = script;

export default __exports__